import fetch from '../../api/fetch'

/**
 *     Action to fetch full quote details
 *
 *  @param  {string} URL [/api/v1/quotes/1/full_info]
 *  @param  {quoteId} integer [Quote ID]
 *  @method GET
 */
export function getFullQuote(quoteId: number) {
    return {
        type: 'GET_FULLQUOTE',
        payload: fetch(`/quotes/${quoteId}/full_info`, { method: 'GET' }),
    }
}

/**
 *     Action to fetch full quote details
 *
 *  @param  {string} URL [/api/v1/quotes/1/full_info]
 *  @param  {quoteId} integer [Quote ID]
 *  @method GET
 */
export function getFullQuoteRenewal(quoteId: number) {
    return {
        type: 'GET_FULLQUOTE_RENEWALS',
        payload: fetch(`/policies/${quoteId}/renewal/edit`, { method: 'GET' }),
    }
}

/**
 *     Action to send the trigger of Editing a specific quote to server
 *
 *  @param  {string} URL [/api/v1/quotes/1/confirmEdit]
 *  @param  {quoteId} integer [Quote ID]
 *  @method POST
 */
export function confirmEditQuote(quoteId: number) {
    return {
        type: 'CONFIRM_EDIT_QUOTE',
        payload: fetch(`/quotes/${quoteId}/confirmEdit`, { method: 'POST' }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/edit.ts